import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "View-1--Streamline-Ultimate.svg",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  width: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("desc", null, "View 1 Streamline Icon: https://streamlinehq.com", -1)
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewStreamline',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#b7b7b7",
  },
  size: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("path", {
      d: "M12 5.251C7.969 5.183 3.8 8 1.179 10.885a1.663 1.663 0 0 0 0 2.226C3.743 15.935 7.9 18.817 12 18.748c4.1 0.069 8.258 -2.813 10.824 -5.637a1.663 1.663 0 0 0 0 -2.226C20.2 8 16.031 5.183 12 5.251Z",
      fill: "none",
      stroke: __props.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M15.75 12A3.75 3.75 0 1 1 12 8.249 3.749 3.749 0 0 1 15.75 12Z",
      fill: "none",
      stroke: __props.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, null, 8, _hoisted_4)
  ]))
}
}

})